module.exports = __webpack_public_path__ + "img/Orange.843f8e78.svg";